<template>
  <div class="tab-wrapper">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            :class="{ active: activeStatus === 'all' }"
            data-toggle="tab"
            role="tab"
            aria-controls="new"
            aria-selected="true"
            @click="activeStatus != 'all' && selectStatus('all')"
          >All</a>
        </li>
        <li class="nav-item" role="presentation" v-for="(status, key) in statusesMaster">
          <a
            class="nav-link"
            :class="{active : activeStatus === `${status.id}`}"
            data-toggle="tab"
            role="tab"
            aria-controls="new"
            aria-selected="true"
            @click="activeStatus != `${status.id}` && selectStatus(status.id)"
            :key="`status-${status.id}-${key}`"
          >{{status.name}}</a>
        </li>
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            :class="{active : activeStatus === 'others'}"
            data-toggle="tab"
            role="tab"
            aria-controls="new"
            aria-selected="true"
            @click="activeStatus != 'others' && selectStatus('others')"
          >Others</a>
        </li>
      </ul>
    </div>
</template>
<script>
export default {
  computed: {
    statusesMaster() {
      return this.$store.getters.statusesMaster;
    }
  },
  mounted(){
    this.scrollToActiveTab();
  },
  methods: {
    scrollToActiveTab() {
      const activeTab = document.querySelector('a.nav-link.active');
      if (activeTab) {
        const activeTabParent = activeTab.parentElement;
        const winWidth = window.innerWidth;
        const atRight = activeTabParent.offsetLeft + activeTabParent.offsetWidth / 2;
        
        if (atRight > winWidth) {
          const diff = atRight - winWidth / 2;
          const tabContainer = document.getElementById('myTab');
          if (tabContainer) {
            tabContainer.scrollLeft = diff;
          }
        }
      }
    }
  },
  props: {
    activeStatus: {
      type: String,
      required: true
    },
    selectStatus: {
      type: Function,
      required: true
    }
  }
};
</script>
<style scoped>
.tab-wrapper .nav-tabs {
  @apply w-full  whitespace-nowrap overflow-x-auto;
}

.tab-wrapper .nav-tabs::-webkit-scrollbar { height: 0; }

.tab-wrapper .nav-item {
  @apply inline-block align-top;
}

.tab-wrapper .nav-link {
  @apply !px-4 py-2 rounded-lg font-semibold text-xs transition-all
         text-main/50 bg-slate-100 text-center flex items-center justify-center
         hover:bg-slate-100 active:scale-95 mb-2 border-b border-inputBorder mr-2;
}

.tab-wrapper .nav-link:focus-visible {
  @apply outline-none ring-2 ring-primary/30;
}

.tab-wrapper .nav-link.active {
  @apply bg-gradient-to-r from-[#00cdac] to-[#62EC14] text-white border-none shadow;
}

.tab-wrapper .nav-link.active,
.tab-wrapper .nav-link:hover {
  @apply text-white;
}
</style>